import type { BookingTranslations } from "../../../pt-BR/event/booking";

export const BOOKING_EN_US: BookingTranslations = {
	reserve: {
		label: "Packages",
		search: "Search for packages",
		create: "Create package",
		empty: {
			title: "No packages for this event",
			subtitle:
				"Create your first package by clicking the ¨Create package¨ button at the top of this page",
		},
		reserveCard: {
			guests: "{{count}} guests",
			promotions: "{{count}} promotions",
			none: "No promotion selected",
			people: "{{count}} confirmed people",
		},
		reserveDetail: {
			title: "Package of",
			confirmed: "{{count}} confirmed",
			of: "of",
			guestsCount: "{{count}} guests",
			delete: "Are you sure you want to delete this product?",
			promotions: "Package Promotions",
			none: "No promotion selected",
			guests: "Guests",
			invoices: "Invoices generated",
			invoiceIssuingLabel: "Issuing invoice...",
			invoiceCanceledLabel: "Invoice canceled",
			invoiceErrorLabel: "Invoice issuing error",
			invoiceModeLabel: "Emission mode:",
			value: "Package value",
			issueInvoice: "Issue invoice",
			copyModal: {
				defaultReserveName: "Copy of {{name}}",
				title: "Create copy of package",
				copy: "Copy",
				text: "Do you want to create a backup copy",
				placeholder: "Package copy name",
				errors: {
					inputs: "The fields were not filled in correctly.",
					name: "The package name is the same as the original name.",
					length: "The package name has not reached the minimum number of characters.",
				},
			},
			modal: {
				title: "Issue invoice for {{name}}",
				issueInvoice: "Issuing note",
				fiscalProfile: "Fiscal Profile",
				cpf: "CPF",
				cnpj: "CNPJ",
				none: "None",
				paymentMethod: "Payment Method",
				fiscalGroup: "Fiscal Group",
				ncm: "NCM",
				cest: "CEST",
				value: "Value",
				remove: "Remove",
				add: "Add tax group",
				tip: "Tip",
				removeTip: "Remove tip",
				invoiceValue: "Invoice value",
				invoiceAlert: "Bills with a value greater than BRL 10,000 will be split.",
				alreadyIssuedInvoiceAlert: "This package already has issued invoices.",
				alreadyIssuedInvoiceConfirm:
					"Are you sure you want to issue? This package already has issued invoices.",
				packageValue: "Package value",
				discount: "Discounts",
				total: "Total",
				chooseOptions: "Choose one of the options",
				addDiscount: "Add discounts to bill",
				completeValue: "Complete the package value",
				recipientRazaoSocial: "Business Name",
				recipientInscricaoEstadual: "State Registration",
				recipientIndicador: "State Registration Indicator",
				recipientAddress: "Address",
				logradouro: "Street",
				numero: "Number",
				complemento: "Complement",
				bairro: "Neighborhood",
				cep: "Postal Code",
				municipio: "City",
				uf: "State",
				optionalTip: {
					title: "Tip (optional)",
					add: "Add tip",
				},
				inputMultiplePaymentsManual: {
					label: "Payment method",
					placeholder: "Select",
					value: "Value",
					add: "Add payment",
				},
				errors: {
					value: "Include some product with value to use this functionality",
					inputs: "Fields were not filled in correctly",
				},
				invoiceProcessing: "The invoice is being processed...",
				invoiceIssuingSoon: "The invoice will be issued shortly",
				invoiceIssuedSuccess: "Invoice issued successfully",
			},
			tableMultiplePayment: {
				columns: {
					paymentMethod: "Payment Method",
					value: "Value",
				},
				total: "Total added",
			},
			peopleDidntArrive: {
				title: "Unknown",
				subtitle: "No information",
			},
			peopleArrived: {
				title: "At the event",
				subtitle: "Already out",
			},
		},
		reserveModal: {
			inactive: "(Promotion inactive)",
			edit: "Edit package",
			create: "Create",
			newTemplate:
				"Attention! The created template can be used by all events in this location.",
			template:
				"The package can be customized, but it will create association with the model to be used in reports and metrics.",
			models: "Models",
			clientInfo: "Customer Information",
			name: "Name",
			estimatedPeopleCount: "Number of guests",
			value: "Package value",
			expiresAt: "Expires in",
			promotion: "Promotion",
			promotionLabel: "Promotion {{number}}",
			updateModal: {
				promotionName: "Promotion name",
				description: "Description",
				productName: "Product Name",
				percentage: "Percent",
			},
			modalTitle: {
				edit: "Edit {{name}}",
				newTemplate: "Create Template",
				template: "Create from template",
				create: "Create package",
			},
			errors: {
				selectedTemplate: "The template could not be found",
				promotion: "No promotion selected",
				inputs: "Please fill in all required fields for the selected category.",
			},
		},
		reserveOptions: {
			create: {
				name: "Create custom package",
				label:
					"Define how the package will be offered and if you want to include a promotion.",
			},
			createWithTemplate: {
				name: "Create from template",
				label:
					"Create a package for your customers based on the templates created earlier.",
			},
			createTemplate: {
				name: "Create new model",
				label: "Create a custom package template for future use in your events.",
			},
			canBeUsedIn: "Can be used in",
			allEvents: "all events",
			fromThisPlace: "from this location",
			managePackages: "Manage packages",
		},
		reserveTemplate: {
			loading: "Loading ...",
			empty: "The location does not have any model registered.",
			remove: "Remove",
			value: "Package value",
			guests: "Guests",
			promotions: "Promotions",
			modalConfirm: {
				title: "Are you sure you want to remove the template?",
				content: "It can no longer be used in any event at this location.",
			},
		},
	},
	reserveReport: {
		label: "Package Report",
		subtitle: {
			none: "No packages active during the event",
			one: "a packagen active during the event",
			default: "{{count}} packages active during event",
		},
	},
};
